import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { IAnagraficaServizioAggiuntivo } from "@common/interfaces/anagraficaServizioAggiuntivo";

export interface AnagraficaServiziState extends EntityState<IAnagraficaServizioAggiuntivo, string> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.ANAGRAFICA_SERVIZIO_AGGIUNTIVO , realtimeEntity: 'AnagraficaServizioAggiuntivo'})
export class AnagraficaServiziStore extends EntityStore<AnagraficaServiziState> {
  constructor() {
    super([]);
  }
}
